import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

export interface PagamentoProposta {
  descTipoPagto?: string;
  tipoPagto?: string;
  descricao: string;
  valor: number;
  dealer?: string;
  chassi?: string;
  numeroProposta?: number | string;
}

export interface PagamentosPropostaResponse {
  idProposta: number;
  pagamentos: PagamentoProposta[];
  valor: number;
}

@Injectable()
export class VeiculosPropostasService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return '';
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    grupo_economico?: any,
    chassi?: any,
    numeroProposta?: any,
    tipo?: any,
    situacao?: any,
    vendaDireta?: any,
    tipo_data?: any,
    userDealerIds?: string): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/controlePropostas/'}`, {
      headers: this.buildHeaders(userDealerIds),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('chassi', chassi.toString())
        .set('numeroProposta', numeroProposta.toString())
        .set('tipo', tipo.toString())
        .set('situacao', situacao.toString())
        .set('venda_direta', vendaDireta.toString())
        .set('tipo_data', tipo_data.toString())
    });
  }

  public getPagamentos(idProposta: number, userDealerIds?: string): Observable<PagamentosPropostaResponse> {
    return this.httpClient.get<PagamentosPropostaResponse>(
      `${this.baseUrlService}/veiculo/controlePropostas/${idProposta}/pagamentos`,
      { headers: this.buildHeaders(userDealerIds) }
    );
  }

  private buildHeaders(userDealerIds?: string): HttpHeaders {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: currentUser.token
    };

    if (userDealerIds) {
      headers['x-user-dealer'] = userDealerIds;
    }

    return new HttpHeaders(headers);
  }

}
